export const PLAN_MANAGEMENT = 'plans'
export const PLANS_AND_RATES_ANALYZE = 'plans-and-rates/analyze/:importBatchId'
export const SMOKER_RATES_ANALYZE = 'smoker-rates/analyze/:importBatchId'
export const SERVICE_AREAS_ANALYZE = 'service-areas/analyze/:importBatchId'
